import React, { useState } from "react";
import { Form } from "@unform/web";

import { fontMedium } from "../../_static/Typography";
import Button from "../../_atom/Buttons/button";
import Checkbox from "../../_molecule/Checkbox";
import Select from "../../_molecule/Select";
import {
  Container,
  Title,
  Description,
  List,
  ListItem,
  SelectContainer,
  ButtonContainer
} from "./styled-components";

const RegistrationTvPreferencesTemplate = ({
  formRef,
  title,
  description,
  buttonText,
  handleSubmit,
  defaultProviders,
  handleProviderGtmClick,
  providersList,
  selectDefaultValueText,
  storedSelectedProvider
}) => {
  const [selectedProvider, setSelectedProvider] = useState(
    storedSelectedProvider
  );

  const handleProviderClick = (provider) => {
    if (selectedProvider === provider) {
      // Unselect provider
      setSelectedProvider({});
      formRef.current.setFieldValue(selectedProvider.value, false);
      if (provider.key === "TV Provider") {
        handleProviderGtmClick("channelUnselected");
      }
    } else {
      // Select provider
      setSelectedProvider(provider);
      if (provider.key === "TV Provider") {
        handleProviderGtmClick("channelSelected");
      } else {
        if (selectedProvider.key === "TV Provider") {
          handleProviderGtmClick("channelUnselected");
        }
        handleProviderGtmClick("cableSelected");
      }
    }
  };

  const isTvProvider = () => {
    if (selectedProvider.value === "tvProvider") {
      return true;
    }
    return !!providersList.find(
      (e) =>
        e.key === selectedProvider.key && e.value === selectedProvider.value
    );
  };

  return (
    <Container>
      <Title data-qa-label="tv-provider-title">{title}</Title>
      <Description data-qa-label="tv-provide-description">
        {description}
      </Description>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <List>
          {defaultProviders.map((provider, index) => (
            <ListItem key={`promo-code-${index.toString()}`}>
              <Checkbox
                id={`tv-provider-${index.toString()}`}
                label={provider.key}
                name={provider.value}
                value={`tv-provider-${index.toString()}`}
                qaLabel="tv-provider-item"
                radioName="tvProviderRadio"
                hasMarginBottom={false}
                isRadio
                onClick={() => {
                  handleProviderClick(provider);
                }}
                isRadioChecked={
                  selectedProvider.value === provider.value ||
                  (isTvProvider() && provider.value === "tvProvider")
                }
              />
            </ListItem>
          ))}
        </List>
        {isTvProvider() && (
          <SelectContainer>
            <Select
              name="selectProviderInput"
              qaLabel="select-tv-provider"
              defaultValue={selectDefaultValueText}
              hasMarginBottom={false}
              handleCustomChange={() => {
                handleProviderGtmClick("cableSelected");
              }}
              options={providersList}
              optionSelected={
                selectedProvider.value !== "tvProvider"
                  ? selectedProvider.value
                  : ""
              }
            />
          </SelectContainer>
        )}
        <ButtonContainer>
          <Button
            size="bigger"
            type="primary"
            hasRoundedCorners
            isStretched
            isUppercase={false}
            hasShadow
            fontFamily={fontMedium}
            isBold={false}
            qaLabel="registration-submit-btn"
            isDisabled={false}
            isLoading={false}
          >
            {buttonText}
          </Button>
        </ButtonContainer>
      </Form>
    </Container>
  );
};

RegistrationTvPreferencesTemplate.defaultProps = {
  title: "Watch TVG at home and on the go",
  description: "Choose your preferred method to watch TVG.",
  buttonText: "Continue"
};

export default RegistrationTvPreferencesTemplate;
